import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBSEN-wo__FMd5MeQUIkQYGFPuqZeHgVNY",
  authDomain: "hyper-e122e.firebaseapp.com",
  projectId: "hyper-e122e",
  storageBucket: "hyper-e122e.appspot.com",
  messagingSenderId: "531281276837",
  appId: "1:531281276837:web:5d5f7f46ecd7cb0439424c",
  measurementId: "G-NB0SWLRYCD"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db };
export { auth }; 